var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTooltipArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.39 6.70452C10.3197 6.63422 10.2243 6.59473 10.1249 6.59473C10.0255 6.59473 9.93009 6.63422 9.85977 6.70452L9.32952 7.23477C9.25922 7.30509 9.21973 7.40046 9.21973 7.4999C9.21973 7.59933 9.25922 7.6947 9.32952 7.76502L13.5644 11.9999L9.32952 16.2348C9.25922 16.3051 9.21973 16.4005 9.21973 16.4999C9.21973 16.5993 9.25922 16.6947 9.32952 16.765L9.85977 17.2953C9.93009 17.3656 10.0255 17.4051 10.1249 17.4051C10.2243 17.4051 10.3197 17.3656 10.39 17.2953L15.4203 12.265C15.4906 12.1947 15.5301 12.0993 15.5301 11.9999C15.5301 11.9005 15.4906 11.8051 15.4203 11.7348L10.39 6.70452Z",
    fill: "#1E2DBE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipArrow);
export default __webpack_public_path__ + "static/media/tooltipArrow.afc1811f931173745dee461966b424b7.svg";
export { ForwardRef as ReactComponent };